export default {"src":"/_next/static/media/sv.9c0d4428.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};